import React from 'react';
import { DebugInfoBlock, DebugInfoLabel, DebugInfoValue, Separator } from './styled';

type Data = {
  label?: string;
  value: string | number | undefined;
};

type Props = {
  data: Data[];
  showSeparator?: boolean;
};
const DebugBlock = ({ data, showSeparator }: Props) => {
  const hasData = data && data.length > 0 && data[0].value;
  if (!hasData) return null;
  const numberOfValues = data.filter((obj) => obj.value).length;

  return (
    <>
      <DebugInfoBlock>
        {data.map(({ label, value }, i) => {
          if (!value) return null;
          const hasComma = i + 1 < numberOfValues;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <span key={`${label}-${value}-${i}`}>
              {label && <DebugInfoLabel>{label}:</DebugInfoLabel>} <DebugInfoValue>{value}</DebugInfoValue>
              {hasComma && ', '}
            </span>
          );
        })}
      </DebugInfoBlock>
      {showSeparator && <Separator />}
    </>
  );
};

export default DebugBlock;
